import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const ProjectInternalNotes = lazy(
  () => import("@/features/projects/project/internalNotes/index.tsx"),
);

export const Route = createFileRoute(
  "/_auth/_app-shell/projects/$projectId/internal-notes",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <ProjectInternalNotes />
    </Suspense>
  );
}
